// @flow
import * as React from "react";
import styled from "styled-components";
import Gettext from "../../common/Gettext";
import * as S from "./styles";
import { StyledPopup as Popup } from "./Popup";
import WarningIcon from "../../Icons/Warning";
import * as TournamentIcon from "../../Icons/Tournaments";
import Tournament from "../Api";
import { FlatButton } from "../../Buttons";
import SuspiciousActivityError from "./SuspiciousActivityError";
import {
  ModalConsumer,
  type ShowModal,
  type HideModal
} from "../../common/ModalProvider";

const IconContainer = styled.div`
  width: 68px;
  margin: 0 auto;
  margin-bottom: 26px;
`;

const Message = styled(S.Title)`
  color: #e74c3c;
`;

type Props = {
  onDismiss: HideModal,
  callback?: () => void,
  message: React.Node,
  style?: string,
  icon?: React.Node,
  children?: React.Node
};

function ErrorPopup({
  onDismiss,
  callback,
  style,
  icon,
  message,
  children
}: Props) {
  return (
    <Popup
      onDismiss={() => onDismiss({ callback })}
      style={style}
      fades={false}
    >
      <S.Wrapper>
        <S.MobileWrapper>
          <Message>{message}</Message>
          <S.Footer>
            {icon != null && <IconContainer>{icon}</IconContainer>}
            {children}
          </S.Footer>
        </S.MobileWrapper>
      </S.Wrapper>
    </Popup>
  );
}

type PopupProps = {
  style: string,
  callback?: () => void,
  onDismiss: HideModal
};

export const NotRunningTournament = (props: PopupProps) => (
  <ErrorPopup
    {...props}
    message={<Gettext>Tournament is not currently running!</Gettext>}
    icon={<WarningIcon width="68px" fill="#e74c3c" />}
  />
);

export const NoRefillNoBid = (props: PopupProps) => (
  <ErrorPopup
    {...props}
    message={
      <Gettext>
        Unfortunately, you can not place such trade at this moment: insufficient
        tournament balance.
      </Gettext>
    }
    icon={<TournamentIcon.PaymentError />}
  />
);

export const NotHaveMoneyRefill = (props: PopupProps) => (
  <ErrorPopup
    {...props}
    message={<Gettext>You do not have enough money to refill</Gettext>}
    icon={<TournamentIcon.PaymentError />}
  >
    <FlatButton
      type="deposit"
      to="/fillup"
      onClick={() => props.onDismiss({ all: true, callback: props.callback })}
    >
      <Gettext>Deposit</Gettext>
    </FlatButton>
  </ErrorPopup>
);

export const NoRealAcc = (props: PopupProps) => (
  <ErrorPopup
    {...props}
    message={
      <Gettext>Please top up your balance to join the tournament</Gettext>
    }
    icon={<TournamentIcon.PaymentError />}
  >
    <FlatButton
      type="deposit"
      to="/fillup"
      onClick={() => props.onDismiss({ all: true, callback: props.callback })}
    >
      <Gettext>Deposit</Gettext>
    </FlatButton>
  </ErrorPopup>
);

export const InsufficientFunds = (props: PopupProps) => (
  <ErrorPopup
    {...props}
    message={<Gettext>Insufficient funds on the account!</Gettext>}
    icon={<TournamentIcon.PaymentError />}
  />
);

export const BalanceNotLowRefill = (props: PopupProps) => (
  <ErrorPopup
    message={
      <Gettext>
        Unfortunately, at this moment buying more tournament coins is not
        possible by the tournament rules
      </Gettext>
    }
    icon={<TournamentIcon.PaymentError />}
    {...props}
  />
);

export const UnknownError = (props: PopupProps) => (
  <ErrorPopup {...props} message={<Gettext>An error has occured.</Gettext>} />
);

type CreateErrorPopupProps = {
  errorCode: null | string,
  showModal: ShowModal,
  api: any
};

class CreateErrorPopup extends React.Component<CreateErrorPopupProps, {}> {
  componentDidMount() {
    const { errorCode, showModal, api } = this.props;

    if (errorCode != null) {
      let modalComponent = null;

      switch (errorCode) {
        case "not_running_tournament":
          modalComponent = NotRunningTournament;
          break;
        case "no_refill_no_bid":
          modalComponent = NoRefillNoBid;
          break;
        case "not_have_money_refill":
          modalComponent = NotHaveMoneyRefill;
          break;
        case "no_real_acc":
          modalComponent = NoRealAcc;
          break;
        case "insufficient_funds":
          modalComponent = InsufficientFunds;
          break;
        case "balance_not_low_refill":
          modalComponent = BalanceNotLowRefill;
          break;
        case "suspicious":
          modalComponent = SuspiciousActivityError;
          break;
        default:
          modalComponent = UnknownError;
          break;
      }

      showModal(modalComponent, {
        id: errorCode,
        callback: api.dismissError
      });
    }
  }

  render() {
    return null;
  }
}

type DetermineErrorPopupProps = {
  errorCode: null | string
};

export function DetermineErrorPopup(props: DetermineErrorPopupProps) {
  return (
    <Tournament.Consumer>
      {api => (
        <ModalConsumer>
          {({ showModal }: { showModal: ShowModal }) => (
            <CreateErrorPopup
              key={props.errorCode}
              showModal={showModal}
              api={api}
              {...props}
            />
          )}
        </ModalConsumer>
      )}
    </Tournament.Consumer>
  );
}



// WEBPACK FOOTER //
// ./src/components/Tournaments/Popups/Error.js